import React from 'react'
import AllFrenchCrown from './AllFrenchCrown'
import './style/frenchcroen.css'
import category from '../../json/category.json'
import line1 from '../../assets/icons/line1.avif'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination ,Autoplay} from 'swiper/modules' 

const SingleImg = () => {

  return (
    <div className='mt-16'>
      <hr />
      <div className=" text-center text-2xl mt-16 text-font header-color ">
        <h2>SHOP BY CATEGORY</h2>
        <div className='flex justify-center line'>
          <img src={line1} alt="" height={50} width={300} style={{ objectFit: 'cover', }} className='line' />
        </div>
      </div>

      <div className="  flex flex-wrap justify-evenly mt-2 mx-14 gap-6">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{

            405: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1290: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1920: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            3000: {
              slidesPerView: 6,
              spaceBetween: 10,
            },
          }}
          modules={[Pagination,Autoplay]}
          className='mySwiper'
        >
          {
            category?.newCate?.map((x, i) => {
              return (
                <SwiperSlide key={i}>
                  <AllFrenchCrown key={i} {...x} cateimg={x.cateimg} catename={x.catename} />
                </SwiperSlide>
              )
            })
          }
        </Swiper>
      </div>
    </div>
  );
}
export default SingleImg
